<template>
    <div class="module-wrap module-right-rate" :rightData="rightData">
      <h2 v-html="moduleTitle"></h2>
      <div class="right-wrap">
        <div class="right-pie">
          <i class="star-icon" v-if="resRightData.right_num"></i>
          <el-progress type="circle"
             v-if="isHasData"
             :percentage="resRightData.question_accuracy*100"></el-progress>
             <div class="show-rate">答题正确率</div>
          <svg
          v-if="isHasData" viewBox="0 0 100 100"
          width="135" height="135" style="position: absolute;z-index: 99">
            <defs>
              <filter id="f2"><feGaussianBlur stdDeviation="2"></feGaussianBlur>
              </filter>
            </defs>
            <path  class="el-progress-circle__path"
                   d="M 50 50 m 0 -48 a 48 48 0 1 1 0 96 a 48 48 0 1 1 0 -96"
                   stroke-linecap="round" stroke="rgba(32, 160, 255,.9)"
                   stroke-width="2" fill="transparent" filter="url(#f2)" :style="circlePathStyle">
            </path>
          </svg>
          <p>{{Math.round(resRightData.question_accuracy*100)}}%</p>
        </div>
        <div class="right-text">
          <h4>我的答题情况</h4>
          <p>总答题：<span>{{resRightData.question_num}}</span></p>
          <p>答对题：<span>{{resRightData.right_num}}</span></p>
          <p>答错题：<span>{{resRightData.error_num}}</span></p>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'ModuleRightRate',
  props: ['moduleTitle', 'rightData'],
  data() {
    return {
      question_accuracy: 0, // 答题正确率
      question_num: null, // 总题数
      right_num: null, // 对题数
      error_num: null, // 错题数
      resRightData: {},
      isHasData: false,
      rightCirle: {
        strokeWidth: 2, // 进度条宽度
        width: 176,
      },
    };
  },
  watch: {
    // rightData () {
    //   this.initData()
    // }
    // axis () {
    //   const r = 63
    //   let angle = 360/100 * rightData.question_accuracy*100
    //   let y = Math.sin(angle) * r
    //   let x = Math.cos(angle) * r
    //   console.log(x,y)
    //   return {
    //     left: x + 'px',
    //     top: y + 'px'
    //   }
    // }
  },
  computed: {
    relativeStrokeWidth() {
      return (this.rightCirle.strokeWidth / this.rightCirle.width * 100).toFixed(1);
    },
    perimeter() {
      const radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle() {
      const { perimeter } = this;
      return {
        strokeDasharray: `${perimeter}px,${perimeter}px`,
        strokeDashoffset: `${(1 - this.resRightData.question_accuracy) * perimeter}px`,
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease',
      };
    },
  },
  mounted() {
  },
  methods: {
    renderRateResult() {
      this.isHasData = true;
      this.resRightData = this.rightData;
    },
  },
};
</script>

<style lang="scss" scoped>
 h2{
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.right-wrap{
  display: flex;
  align-items: center;
  padding-left: 160px;
  .right-pie{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    margin-right: 80px;
    background: url("~@/assets/img/answer_right_bg.png") no-repeat;
    background-size: cover;
    p{
      position: absolute;
      top: 30px;
      left: 30px;
      font-size: 20px;
    }
    .star-icon{
      position: absolute;
      z-index: 9;
      left: 85px;
      top: 32px;
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/img/star.png") center center no-repeat;
      background-size: cover;
    }
    .show-rate {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
    }
    /deep/ .el-progress__text{
      display: none;
    }
  }
  .right-text{
    h4{
      font-size: 20px;
      color: #666666;
      line-height: 20px;
      margin-bottom: 24px;
      font-weight: 500;
    }
    p{
      margin-bottom: 4px;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
}
</style>
